// removed by extract-text-webpack-plugin
module.exports = {"site-link":"SiteLink-module__site-link___3sbwP"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/SiteLinks/SiteLink.module.scss
// module id = 180
// module chunks = 0 1